import React from "react";
import "./InputGlobal.scss";

function InputGlobal({
  placeholder,
  className,
  name,
  type,
  onChange,
  value,
  onFocus,
  onBlur,
}) {
  return (
    <input
      autoComplete="on"
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      value={value}
      onBlur={onBlur}
    />
  );
}

export default InputGlobal;
